var React = require('react');

function MoreComponent (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"faq/question/mobile","transform":"translate(-268.000000, -17.000000)","fill":"#D8D8D8"},React.createElement("g",{"id":"faq/question"},React.createElement("g",{"id":"content","transform":"translate(8.000000, 14.000000)"},React.createElement("path",{"d":"M268,9 L268,3 L266,3 L266,9 L260,9 L260,11 L266,11 L266,17 L268,17 L268,11 L274,11 L274,9 L268,9 Z","id":"icons/ic-more"})))))]);
}

MoreComponent.defaultProps = {"width":"14px","height":"14px","viewBox":"0 0 14 14","version":"1.1"};

module.exports = MoreComponent;

MoreComponent.default = MoreComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/Counter/images/more.component.svg
// module id = 691
// module chunks = 0